import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, MapPin, Radio, Video, Search } from "lucide-react";
import api from "@/lib/api";

const items = [
  { to: "/", label: "होम", icon: Home, testid: "mnav-home" },
  { to: "/cg", label: "आप का शहर", icon: MapPin, testid: "mnav-city" },
  { to: "/live", label: "Live TV", icon: Radio, testid: "mnav-live", liveable: true },
  { to: "/videos", label: "Video", icon: Video, testid: "mnav-videos" },
  { to: "/search", label: "खोज", icon: Search, testid: "mnav-search" },
];

export default function MobileBottomNav() {
  const loc = useLocation();
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    let mounted = true;
    const check = () => api.get("/youtube/live").then((r) => { if (mounted) setIsLive(!!r.data?.is_live); }).catch(() => {});
    check();
    const t = setInterval(check, 60000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  if (loc.pathname.startsWith("/admin") || loc.pathname.startsWith("/reporter")) return null;
  const isActive = (to) => (to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(to));

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
      data-testid="mobile-bottom-nav"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="grid grid-cols-5">
        {items.map(({ to, label, icon: Icon, testid, liveable }) => {
          const active = isActive(to);
          const showLive = liveable && isLive;
          return (
            <li key={to}>
              <Link
                to={to}
                data-testid={testid}
                className={`relative flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-bold transition ${
                  active ? "text-[#EA580C]" : (showLive ? "text-red-600" : "text-slate-500 hover:text-[#DC2626]")
                }`}
              >
                {active && <span className="absolute top-0 left-6 right-6 h-0.5 rounded-b-full bg-gradient-to-r from-[#DC2626] to-[#EA580C]"/>}
                <div className="relative">
                  <Icon className={`w-5 h-5 ${active ? "scale-110" : ""}`} strokeWidth={active ? 2.5 : 2}/>
                  {showLive && (
                    <span className="absolute -top-1 -right-2 flex items-center" data-testid="mnav-live-badge">
                      <span className="relative flex h-3 w-3">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"/>
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600 border-2 border-white"/>
                      </span>
                    </span>
                  )}
                </div>
                <span className={showLive && !active ? "font-black" : ""}>
                  {showLive ? "🔴 LIVE" : label}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
